import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LeapmotorElementDTO } from '../models/elements-dto';
import { DataTablesResponse } from '../models/datatables';
import { ChangeOrderDTO } from '../models/change-order-dto';


@Injectable({
  providedIn: 'root'
})

export class ElementService {

  private pathAPI = environment.urlAPI;
  private controller = "LeapmotorElement/";

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<LeapmotorElementDTO> {
    return this.http.get<LeapmotorElementDTO>(this.pathAPI + this.controller + id);
  }

  public GetLeapmotorElementLst(type: number): Observable<LeapmotorElementDTO[]> {
    return this.http.get<LeapmotorElementDTO[]>(this.pathAPI + this.controller + "GetLeapmotorElementLst/" + type);
  }
  
  public post(data: FormData): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: FormData): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public changeOrder(data: ChangeOrderDTO[]): any {
    return this.http.post<any>(this.pathAPI + this.controller + 'ChangeOrder', data);
  }

  public getDataTable(data: any, idType: string): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/' + idType, data);
  }

  public getDataTableOrder(data: any,idType: string): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTableOrder/' + idType, data);
  }



}
